/** SignIn API — Faz 1.4 createApi factory. (signup endpoint'leri ile paylaşır) */
import {createApi} from './_factory'
import type {CommonNs, SignUpNs} from '@shared/types'

const api = createApi('signup')

export const SignInApi = {
  createNewPassword: (data: SignUpNs.CreatePasswordRequest) =>
    api.post<SignUpNs.CreatePasswordRequest, CommonNs.GenericResponse>('create-new-password', data),
  resetPassword: (data: SignUpNs.ResetPasswordRequest) =>
    api.post<SignUpNs.ResetPasswordRequest, SignUpNs.ResetPasswordResponse>('reset-password', data),
}
